import * as type from '../../types/trans';
import { AUTHMOH, AUTHFOLIO } from '../../types/onboarding';
import { HEADER_KEY } from '../../types/preloginType';

let init = {
    cvlData: null,
    guestMenu: null,
    guestNew: true,
    onboardAuth: null,
    onboardFolio: null,
    existingBox: null,
    headerKey: "MF",
    cartCountData: null,
    selectedRIData: {},
    RIStatus: false
}

export default function authDetails(state = init, action) {
    switch (action.type) {
        case type.SAVE_CVL_DATA:
            return {
                ...state,
                cvlData: action.payload
            }

        case type.UPDATE_GUEST_MENU:
            return {
                ...state,
                guestMenu: true,
                existingBox: false,
                guestNew: (typeof action.payload == "boolean") ? action.payload : true
            }
        case type.RESET_GUEST_MENU:
            return {
                ...state,
                guestMenu: false,
                existingBox: true,
                guestNew: true
            }
        case AUTHMOH:
            return {
                ...state,
                onboardAuth: action.payload
            }
        case AUTHFOLIO:
            return {
                ...state,
                onboardFolio: action.payload
            }

        case type.EXISTING_BOX:
            return {
                ...state,
                existingBox: action.payload
            }
        case HEADER_KEY:
            return {
                ...state,
                headerKey: action.payload
            }

        case type.GET_CART_COUNT_SUCCESS:
            return {
                ...state,
                cartCountData: action.payload
            }

        case type.GET_CART_COUNT_FAILURE:
            return {
                ...state,
                cartCountData: action.payload
            }

        case type.UPDATE_GUEST_TYPE:
            return {
                ...state,
                guestNew: action.payload
            }

        case type.SELECTED_RI_DATA:
            return {
                ...state,
                selectedRIData: action.payload
            }

        case type.RIStatus:
            return {
                ...state,
                RIStatus: action.payload
            }
        default:
            return state
    }
}